import { produce } from 'immer'
import { State } from '../../typings'
import type { SetEditActivityIdAction } from './typings'

export const setEditActivityIdProducer = produce<
  State,
  [SetEditActivityIdAction['payload']]
>((draft, payload) => {
  draft.editActivityId = payload
})
